import * as _ from 'lodash'

import { BaseDto } from "../base.dto"
import { PagingDto } from '../paging.dto'
import { MallPublicDto } from './mall-public.dto'
import { BaseError } from '../../errors'
import { FileDto } from '../file.dto'

export interface TranslationItem {
  language?: string;
  languageCode?: string;
  name: string;
  description?: string;
}

export type NameOrTranslation = string | { en: string; kh: string };

/** Get a single display string from name/description (list screens). */
export function getDisplayString(val: string | { en?: string; kh?: string } | undefined): string {
  if (val == null) return '';
  if (typeof val === 'string') return val;
  const o = val as { en?: string; kh?: string };
  return o.en || o.kh || '';
}

/** Get English value from name/description (edit screens). */
export function getEn(val: string | { en: string; kh: string } | undefined): string {
  if (val == null || typeof val === 'string') return '';
  return (val as { en: string; kh: string }).en ?? '';
}

/** Get Khmer value from name/description (edit screens). */
export function getKh(val: string | { en: string; kh: string } | undefined): string {
  if (val == null || typeof val === 'string') return '';
  return (val as { en: string; kh: string }).kh ?? '';
}

/** Ensure name/description is object for editing. */
export function ensureNameObject(obj: string | { en: string; kh: string } | undefined | null): { en: string; kh: string } {
  if (obj == null || typeof obj === 'string') return { en: '', kh: '' };
  return obj as { en: string; kh: string };
}

export interface GovernTenantCategoryFilters {
  mallId: string;
  enabled: boolean;
  search: string;
  tenantId?: string;
}

export interface GovernTenantCategoryState {
  tenantCategories: GovernTenantCategoryDto[];
  isLoading: boolean;
  error: BaseError | null;
  pageInfo: {
    page: number;
    pageSize: number;
    collectionSize: number;
    from: number;
    to: number;
  };
  filters: GovernTenantCategoryFilters;
  malls: MallPublicDto[];
}

/** F&B category for tenants (BR004). DB: id, enabled, imageId, mobileImageId, khImageId, khMobileImageId, createdAt, updatedAt */
export class GovernTenantCategoryDto extends BaseDto {
  translations?: TranslationItem[]
  name?: string | { en: string; kh: string }
  description?: string | { en: string; kh: string }
  enabled?: boolean
  mallId?: string
  image?: FileDto | null
  mobileImage?: FileDto | null
  khImage?: FileDto | null
  khMobileImage?: FileDto | null

  static create({ id, name, description, enabled, image, mobileImage, khImage, khMobileImage, mallId }: GovernTenantCategoryDto) {
    return _.assign<GovernTenantCategoryDto>({
      id: id || null,
      name: name || { en: '', kh: '' },
      description: description || { en: '', kh: '' },
      enabled: enabled ?? true,
      image: image || null,
      mobileImage: mobileImage || null,
      khImage: khImage || null,
      khMobileImage: khMobileImage || null,
      mallId: mallId || null
    })
  }
}

export class FindGovernTenantCategoryDto extends PagingDto {
  enabled?: boolean
  search?: string
  tenantId?: string
  mallId?: string
}

export class GovernTenantCategoryFormDto {
  translations: TranslationItem[]
  enabled?: boolean
  imageId?: string
  mobileImageId?: string
  khImageId?: string
  khMobileImageId?: string
} 